import pageEvaluations from "./evaluation";
import pagePeriod from "./period";
import pageHome from "./home";
import pagePlanTarget from "./planTarget";
import pagePersonalTarget from "./personalTarget";
import pageLogin from "./login";
import msg from "./msg";
import icon from "./icon";
import targetSetting from "@/locales/targetSetting";
import index from "@/locales/index";
import managerTargetSettings from "@/locales/managerTargetSettings";
import teamTarget from "@/locales/teamTarget";
import settingsCommon from "@/locales/settingsCommon";
import transferMember from "@/locales/transferMember";

export default {
  systemName: "人事評価システム",
  index,
  msg,
  button: {
    clear: "クリア",
    search: "検索",
    ok: "保存",
    download: "ダウンロード",
    cancel: "キャンセル",
    save: "SAVE",
    back: "戻る",
    reject: "差し戻し",
    approve: "承認",
  },
  navBars: {
    profile: "プロフィール",
    changePassword: "パスワード変更",
    signOut: "ログアウト",
  },
  page403: {
    subject: "403 - アクセス拒否",
    description: "このページへのアクセスが許可されていません。",
  },
  page404: {
    subject: "404 - NOT FOUND",
    description: "お探しのページが見つかりません。",
  },
  tableText: {
    numberOfRecord: "レコード数",
    loadingText: "読み込み中。。。待って下さい",
    noResultsText:
      "検索条件に該当するデータが見つかりません。検索条件を見直してください。",
    noDataText:
      "検索条件に該当するデータが見つかりません。検索条件を見直してください。",
  },
  pageLogin,
  pageEvaluations,
  pagePeriod,
  pageHome,
  pagePlanTarget,
  pagePersonalTarget,
  settingsCommon,
  icon,
  targetSetting,
  managerTargetSettings,
  teamTarget,
  transferMember,
};
